/** host should be document.location.host
 * e.g. 'portal-api-dev.clmi-dev.io', 'app.ch.clmi.io' etc.
 * */
export const getDomainFromHost = (host?: string) =>
    host?.split('.')?.slice(1)?.join('.') ?? 'clmi-dev.io';
